import { Component, OnInit, Input } from '@angular/core';
import { QueryResult } from '../ngx-query-editor.models' ;

@Component({
  selector: 'lib-result-viewer',
  templateUrl: './result-viewer.component.html',
  styleUrls: ['./result-viewer.component.scss']
})
export class ResultViewerComponent implements OnInit {

  public displayedColumns: string[] = [];
  public displayedData: any;
  private _result: QueryResult;

  @Input()
  get result(): QueryResult {
    return this._result;
  }
  set result(value: QueryResult) {
    this._result = value;
    this.displayedData = this.result.result;
    this.displayedColumns = this.result.schema;
  }

  ngOnInit() {
  }
}
